export enum ActionTypes {
  GetEmailApiFeatures = 'getEmailApiFeatures',
  GetEmailApiFeaturesSuccess = 'getEmailApiFeatures.success',
  GetEmailApiFeaturesFailure = 'getEmailApiFeatures.failure',
}
